import React, { useState } from "react"
import { Link } from "gatsby"
import styled from "@emotion/styled"
import { css } from "@emotion/core"

import HeaderPattern from "../../content/assets/header.svg"
// import Sun from "../../content/assets/sun.svg"
// import { Moon } from "react-feather"
import MaxWidthContainer from "./max-width-container"
import DarkToggle from "./dark-mode-toggle"

import UseAnimations from "react-useanimations"
import menu from "react-useanimations/lib/menu4"

const NavItem = styled.li`
  display: inline;
`
const navLink = css`
  text-decoration: none;
  display: inline-block;
  padding: 8px;
  font-weight: bold;
  color: var(--color-text);
  padding-right: 50px;
  font-size: 14px;
  &:hover {
    color: var(--color-interactive-light);
    transition: all 100ms linear;
    -webkit-transition: all 100ms linear;
  }
  @media (max-width: 768px) {
    padding-bottom: 30px;
    display: block;
  }
`

function HeaderTile({ height }) {
  return (
    <div
      css={css`
        position: relative;
        height: 100%;
        grid-row: 1;
        &:hover {
          span {
            height: 0px;
            transition: height 300ms ease;
            -webkit-transition: height 300ms ease;
          }
        }
      `}
    >
      <span
        css={css`
          height: ${height}px;
          background: var(--color-background);
          position: absolute;
          bottom: 0px;
          left: 0px;
          right: 0px;
          transition: height 1200ms ease;
          -webkit-transition: height 1200ms ease;
        `}
      ></span>
    </div>
  )
}

const menuOpen = css`
  position: absolute;
  z-index: 2;
  top: 100px;
`

export default function DecorativeHeader() {
  const [menuChecked, setChecked] = useState(false)
  const heights = [10, 15, 20, 25, 30, 25, 20, 15, 10, 5, 10, 15, 20, 15, 10]
  return (
    <div
      css={css`
        height: ${menuChecked ? "400px" : "200px"};
        background: var(--color-header-gradient);
        position: relative;
        transition: all 100ms ease-out;
        -webkit-transition: all 100ms ease-out;
        @media print {
          display: none;
        }
      `}
    >
      <MaxWidthContainer>
        <nav
          css={css`
            position: relative;
            z-index: 1;
          `}
        >
          <Link
            css={css`
              ${navLink};
              padding-top: 5px;
              float: left;
              background: var(--color-accent-gradient);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              letter-spacing: 2px;
              &:hover {
                background: var(--color-accent-gradient-alt);
                -webkit-background-clip: text;
              }
            `}
            to="/"
          >
            <h2>TCBR</h2>
          </Link>
          <ul
            css={css`
              display: ${menuChecked
                ? "block"
                : "var(--no-mobile-inline-block)"};
              list-style-type: none;
              margin: 0;
              float: left;
              ${menuChecked && menuOpen};
            `}
          >
            <NavItem>
              <Link css={navLink} to="/blog/">
                Blog
              </Link>
            </NavItem>
            <NavItem>
              <Link css={navLink} to="/portfolio/">
                Portfolio
              </Link>
            </NavItem>
            <NavItem>
              <Link css={navLink} to="/cv/">
                CV
              </Link>
            </NavItem>
            <NavItem>
              <Link css={navLink} to="/contact/">
                Contact
              </Link>
            </NavItem>
          </ul>
          <ul
            css={css`
              display: inline-block;
              list-style-type: none;
              margin-left: auto;
              float: right;
            `}
          >
            <NavItem>
              <button
                aria-label="Navigation Menu"
                css={css`
                  display: var(--mobile-only-flex);
                  float: right;
                  position: relative;
                  border-radius: 5;
                  width: 50px;
                  height: 40px;
                  -moz-box-align: center;
                  align-items: center;
                  -moz-box-pack: center;
                  justify-content: center;
                  // background: var(--color-primary);
                  // stroke: var(--color-text);
                  &:hover {
                    fill: var(--color-gradient-secondary);
                    transition: all 100ms linear;
                    -webkit-transition: all 100ms linear;
                  }
                `}
              >
                <UseAnimations
                  reverse={menuChecked}
                  onClick={() => {
                    setChecked(!menuChecked)
                    // So the navlink needs to become a block
                    // ul needs to become visible and be positioned absolute at 80 top
                    // need to make the list above svg using z-index 2
                    // need to make the header larger to fit the text
                  }}
                  size={35}
                  strokeColor={"var(--color-text)"}
                  // wrapperStyle={{ marginTop: '5px' }}
                  animation={menu}
                />
              </button>
            </NavItem>
            <NavItem>
              <DarkToggle />
            </NavItem>
          </ul>
        </nav>
      </MaxWidthContainer>
      {/* <div
        css={css`
          overflow: hidden;
          display: block;
          position: absolute;
          left: 0px;
          right: 0px;
          bottom: 0px;
          width: 100%;
          height: 90px;
          transform: translateY(2px);
        `}
      >
        <HeaderPattern
          css={css`
            position: absolute;
            bottom: 0;
            fill: var(--color-background);
            width: 100%;
          `}
        />
      </div> */}
      <div
        css={css`
          display: grid;
          position: absolute;
          bottom: 0px;
          width: 100%;
          grid-template-columns: repeat(auto-fit, minmax(80px, 1fr));
          height: 100%;
          z-index: 0;
        `}
      >
        {heights.map(h => (
          <HeaderTile height={h * 2} />
        ))}
      </div>
    </div>
  )
}
